<template>
  <ModalForm
    id="select-environment-modal"
    title="Select Environment"
    :onSubmit="submit"
    submitButtonText="Publish"
    @hidden="onHide"
  >
    <validation-provider name="Select Environment" rules="required">
      <div class="form-group form-check" v-for="option in options" :key="option">
        <input
          class="form-check-input"
          type="checkbox"
          :id="`select-environment-${option}`"
          :value="option"
          v-model="environmentsToUpdate"
        />
        <label class="form-check-label text-capitalize" :for="`select-environment-${option}`">{{
          option
        }}</label>
      </div>
    </validation-provider>
  </ModalForm>
</template>

<script>
import ModalForm from '@/components/MainContent/ModalForm.vue'
import { ENVIRONMENTS } from '@/utils/constants'

// While running a dev server, only the `local` publish target is offered (and
// pre-checked) so we don't accidentally write to a real Sandbox/Production
// backend from a developer machine. Deployed Console builds keep the original
// Production + Sandbox options.
const isDevMode = process.env.NODE_ENV === 'development'

const OPTIONS = isDevMode
  ? [ENVIRONMENTS.LOCAL]
  : [ENVIRONMENTS.PRODUCTION, ENVIRONMENTS.SANDBOX]

const DEFAULT_SELECTED = [...OPTIONS]

export default {
  name: 'EmulatorSelectEnvironmentModal',
  data: () => ({
    environmentsToUpdate: [...DEFAULT_SELECTED],
    options: OPTIONS,
  }),
  components: {
    ModalForm,
  },
  methods: {
    submit() {
      this.$emit('submit', this.environmentsToUpdate)
    },
    onHide() {
      this.resetState()
    },
    resetState() {
      this.environmentsToUpdate = [...DEFAULT_SELECTED]
    },
  },
}
</script>
